import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {Tooltip, Typography} from '@mui/material';

const TopToolTip = ({icon, children, ...otherProps}) => {
    return (
        <Tooltip
            title={
                Array.isArray(children)
                    ? children.map((x) => <p>{x}</p>)
                    : children
            }
            {...otherProps}>
            {icon}
        </Tooltip>
    );
};

interface PLFormLabelProps {
    toolTip?;
    icon?;
    children;
    [key: string]: any;
}

export const PLFormLabel = ({
    toolTip,
    icon,
    children,
    ...otherProps
}: PLFormLabelProps) => {
    if (toolTip) {
        if (!icon) {
            icon = <HelpOutlineIcon fontSize="small" />;
        }
        return (
            <div style={{display: 'inline-flex', minWidth: '6rem'}}>
                <Typography {...otherProps}>{children}</Typography>{' '}
                <TopToolTip icon={icon}>{toolTip}</TopToolTip>
            </div>
        );
    }
    return <Typography {...otherProps}>{children}</Typography>;
};
